import axiosInstance from "../utils/axios";

export const getAccountProfile =
  () => axiosInstance.get("/account/profile");

export const updateAccountProfile =
  data => axiosInstance.post(
    "/account/profile",
    data
  );

export const getAccountAddresses =
  () => axiosInstance.get(
    "/account/addresses"
  );

export const createAccountAddress =
  data => axiosInstance.post(
    "/account/addresses",
    data
  );

export const updateAccountAddress =
  (id, data) => axiosInstance.put(
    `/account/addresses/${id}`,
    data
  );

export const deleteAccountAddress =
  id => axiosInstance.delete(
    `/account/addresses/${id}`
  );

export const setDefaultAccountAddress =
  id => axiosInstance.post(
    `/account/addresses/${id}/default`
  );

export const getAccountVouchers =
  () => axiosInstance.get(
    "/account/vouchers"
  );

export const getAccountDevices =
  () => axiosInstance.get(
    "/account/devices"
  );

export const revokeAccountDevice =
  uuid => axiosInstance.post(
    `/account/devices/${encodeURIComponent(uuid)}/revoke`
  );
